import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { LABEL_ANALYSIS_BOOLEAN_FILTERS } from "../../../services/labelAnalysis";
import LocationLabelTriStateChip from "./LocationLabelTriStateChip";

const formatDate = (value) => {
  if (!value) {
    return "Not available";
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString();
};

const DetailField = ({ label, children }) => (
  <TableRow>
    <TableCell sx={{ width: "32%", fontWeight: 600, verticalAlign: "top" }}>{label}</TableCell>
    <TableCell sx={{ wordBreak: "break-word" }}>{children ?? "Not available"}</TableCell>
  </TableRow>
);

function LocationLabelDetailMetadata({ item }) {
  if (!item) {
    return (
      <Typography variant="body2" color="text.secondary">
        No record selected.
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      <Typography variant="h6">{item.productName !== "—" ? item.productName : item.countryLabel}</Typography>
      <Table size="small" sx={{ border: "1px solid #e0e0e0", backgroundColor: "#fff" }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600 }}>Field</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <DetailField label="Label analysis ID">
            {item.id || "Not available"}
          </DetailField>
          <DetailField label="Product">{item.productName}</DetailField>
          <DetailField label="Retailer">{item.retailerLabel}</DetailField>
          <DetailField label="Country">{item.countryLabel}</DetailField>
          <DetailField label="Grade">{item.grade || "Not available"}</DetailField>
          <DetailField label="Quality">{item.quality || "Not available"}</DetailField>
          {LABEL_ANALYSIS_BOOLEAN_FILTERS.map((filter) => (
            <DetailField key={filter.key} label={filter.label}>
              <LocationLabelTriStateChip value={item[filter.key]} />
            </DetailField>
          ))}
          <DetailField label="Created">{formatDate(item.dateCreated)}</DetailField>
          <DetailField label="Updated">{formatDate(item.dateUpdated)}</DetailField>
        </TableBody>
      </Table>
    </Stack>
  );
}

export default LocationLabelDetailMetadata;
